export default __webpack_public_path__ + "static/media/empty-filtered-projects-board.93db4090.svg";